export class M3SaldosXCuenta{
    public Documento:string;
    public TDocTitular:number;
    public NDocTitular:string;
    public NomCuenta:string;
    public ValCuenta:number;
}